import React, { useState, useCallback, Suspense, lazy } from 'react';
import Header from '../components/Header';
import AtelierHero from '../components/AtelierHero';
import AtelierServices from '../components/AtelierServices';
import Catalogue from '../components/Catalogue';
import CraftStory from '../components/CraftStory';
import CraftProcess from '../components/CraftProcess';
import GoogleReviews from '../components/GoogleReviews';
import ServiceArea from '../components/ServiceArea';
import CraftGallery from '../components/CraftGallery';
import Footer from '../components/Footer';
import StickyBar from '../components/StickyBar';
import useDocumentMeta from '../hooks/useDocumentMeta';
import siteMeta from '../data/siteMeta.json';

const DesignView = lazy(() => import('../components/DesignView'));
const HOME_TITLE = siteMeta.title;
const HOME_DESC = siteMeta.description;

const Home = () => {
  useDocumentMeta({
    title: HOME_TITLE, description: HOME_DESC, canonical: 'https://fairfix.com.au/',
    ogTitle: HOME_TITLE, ogDescription: HOME_DESC, ogUrl: 'https://fairfix.com.au/',
    robots: 'index, follow', twitterTitle: HOME_TITLE, twitterDescription: HOME_DESC,
  });
  const [design, setDesign] = useState(null);
  const openDesign = useCallback((target) => setDesign(target), []);
  const closeDesign = useCallback(() => setDesign(null), []);

  return (
    <div className="home home--craft home--atelier">
      <Header />
      <main id="main-content" tabIndex={-1}>
        <AtelierHero><GoogleReviews editorial nearHero /></AtelierHero>
        <AtelierServices />
        <CraftGallery />
        <CraftStory />
        <Catalogue onOpen={openDesign} />
        <CraftProcess />
        <ServiceArea />
      </main>
      <Footer editorial />
      <StickyBar />
      {design && (
        <Suspense fallback={<div className="craft-loading" role="status">Opening design…</div>}>
          <DesignView open target={design} onClose={closeDesign} />
        </Suspense>
      )}
    </div>
  );
};

export default Home;
